import { render } from "./competition.vue?vue&type=template&id=6ea34737&scoped=true"
import script from "./competition.vue?vue&type=script&lang=js"
export * from "./competition.vue?vue&type=script&lang=js"

import "./competition.vue?vue&type=style&index=0&id=6ea34737&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea34737"]])

export default __exports__